import { render, staticRenderFns } from "./SyncStatusBadge.vue?vue&type=template&id=8bdc2548&scoped=true&"
import script from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./SyncStatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SyncStatusBadge.vue?vue&type=style&index=0&id=8bdc2548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc2548",
  null
  
)

export default component.exports